// Fix for Turbo scroll restoration based on GitHub issue solutions
// https://github.com/hotwired/turbo/issues/37

let scrollPositions = new Map()

// Save scroll position before navigation
addEventListener("turbo:click", (event) => {
  const currentUrl = window.location.href
  const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
  const scrollLeft = document.documentElement.scrollLeft || document.body.scrollLeft
  
  
  scrollPositions.set(currentUrl, { top: scrollTop, left: scrollLeft })
  
  // Also save to sessionStorage as backup
  try {
    sessionStorage.setItem('turbo-scroll-' + currentUrl, JSON.stringify({
      top: scrollTop,
      left: scrollLeft,
      timestamp: Date.now()
    }))
  } catch (e) {
    // Storage full, ignore
  }
})

// Also handle clicks on dynamically loaded table links
document.addEventListener('click', (event) => {
  const link = event.target.closest('a[href]')
  if (link && link.classList.contains('product-table-link')) {
    const currentUrl = window.location.href
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
    const scrollLeft = document.documentElement.scrollLeft || document.body.scrollLeft
    
    
    scrollPositions.set(currentUrl, { top: scrollTop, left: scrollLeft })
    
    try {
      sessionStorage.setItem('turbo-scroll-' + currentUrl, JSON.stringify({
        top: scrollTop,
        left: scrollLeft,
        timestamp: Date.now()
      }))
    } catch (e) {
      // Storage full, ignore
    }
  }
})

// Save scroll position before form submissions
addEventListener("turbo:submit-start", () => {
  const currentUrl = window.location.href
  const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
  const scrollLeft = document.documentElement.scrollLeft || document.body.scrollLeft
  
  scrollPositions.set(currentUrl, { top: scrollTop, left: scrollLeft })
})

// Restore scroll position after page loads
addEventListener("turbo:load", () => {
  // Use setTimeout to ensure this runs after Turbo's own scroll handling
  setTimeout(() => {
    const currentUrl = window.location.href
    let position = scrollPositions.get(currentUrl)
    
    // Fallback to sessionStorage if not in memory
    if (!position) {
      try {
        const stored = sessionStorage.getItem('turbo-scroll-' + currentUrl)
        if (stored) {
          const parsed = JSON.parse(stored)
          // Only use if less than 10 minutes old
          if (Date.now() - parsed.timestamp < 600000) {
            position = { top: parsed.top, left: parsed.left }
          }
        }
      } catch (e) {
        // Invalid JSON, ignore
      }
    }
    
    if (position) {
      // Disable smooth scrolling temporarily for instant positioning
      const originalBehavior = document.documentElement.style.scrollBehavior
      document.documentElement.style.scrollBehavior = 'auto'
      
      window.scrollTo(position.left, position.top)
      
      // Restore smooth scrolling after a brief delay
      setTimeout(() => {
        document.documentElement.style.scrollBehavior = originalBehavior
      }, 50)
    }
  }, 0)
})

// Handle browser back/forward navigation
addEventListener("turbo:restore", () => {
  // Use a longer timeout for restore events as they can be more delayed
  setTimeout(() => {
    const currentUrl = window.location.href
    let position = scrollPositions.get(currentUrl)
    
    if (!position) {
      try {
        const stored = sessionStorage.getItem('turbo-scroll-' + currentUrl)
        if (stored) {
          const parsed = JSON.parse(stored)
          position = { top: parsed.top, left: parsed.left }
        }
      } catch (e) {
        // Invalid JSON, ignore
      }
    }
    
    if (position) {
      document.documentElement.style.scrollBehavior = 'auto'
      window.scrollTo(position.left, position.top)
      setTimeout(() => {
        document.documentElement.style.scrollBehavior = ''
      }, 50)
    }
  }, 50)
})

// Clean up old positions periodically
setInterval(() => {
  // Keep only last 50 positions
  if (scrollPositions.size > 50) {
    const entries = Array.from(scrollPositions.entries())
    scrollPositions.clear()
    entries.slice(-25).forEach(([url, pos]) => {
      scrollPositions.set(url, pos)
    })
  }
  
  // Clean up old sessionStorage entries
  try {
    const keys = Object.keys(sessionStorage)
    const scrollKeys = keys.filter(key => key.startsWith('turbo-scroll-'))
    if (scrollKeys.length > 50) {
      const entries = scrollKeys.map(key => {
        try {
          const data = JSON.parse(sessionStorage.getItem(key))
          return { key, timestamp: data.timestamp || 0 }
        } catch {
          return { key, timestamp: 0 }
        }
      })
      
      entries.sort((a, b) => a.timestamp - b.timestamp)
      entries.slice(0, -25).forEach(entry => {
        sessionStorage.removeItem(entry.key)
      })
    }
  } catch (e) {
    // Storage error, ignore
  }
}, 60000) // Clean up every minute